import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

// Feature selector
export const selectAuthState = createFeatureSelector<AuthState>('auth');

// User selectors
export const selectUser = createSelector(selectAuthState, (state: AuthState) => state.currentUser);

export const selectAccessToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.access_token,
);

// Permissions selectors
export const selectPermissions = createSelector(
  selectAuthState,
  (state: AuthState) => state.permissions,
);

// Auth status selectors
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => state.isAuthenticated,
);

export const selectIsLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.isLoading,
);

export const selectMenus = createSelector(
  selectAuthState,
  (state: AuthState) => state.menus,
);

export const selectError = createSelector(selectAuthState, (state: AuthState) => state.error);

// Permission codes selector
export const selectPermissionCodes = createSelector(
  selectPermissions,
  (permissions) => {
    if (!permissions) return [];
    return permissions
      .map(p => p.FUNC_CODE)
      .filter(code => code != null) as string[];
  }
);

// Menu codes selector
export const selectMenuCodes = createSelector(
  selectMenus,
  (menus) => {
    const codes: string[] = [];
    const extractCodes = (menuList: typeof menus) => {
      menuList.forEach(menu => {
        if (menu.C_MENU_CODE) {
          codes.push(menu.C_MENU_CODE);
        }
        if (menu.LIST_CHILD && menu.LIST_CHILD.length > 0) {
          extractCodes(menu.LIST_CHILD);
        }
      });
    };
    extractCodes(menus);
    return codes;
  }
);

// Check if user has specific permission
export const selectHasPermission = (permissionCode: string) =>
  createSelector(
    selectPermissionCodes,
    (codes) => codes.includes(permissionCode)
  );

// Check if user has specific menu access
export const selectHasMenuCode = (menuCode: string) =>
  createSelector(
    selectMenuCodes,
    (codes) => codes.includes(menuCode)
  );